import "./AvailabilitySection.css";

function AvailabilitySection({
  formData,
  updateField,
}) {
  return (
    <div className="food-form-section">

      <h3 className="section-title">
        Availability & Inventory
      </h3>

      <div className="availability-grid">

        {/* Preparation Time */}

        <div className="form-group">

          <label>
            Preparation Time (Minutes) *
          </label>

          <input
            type="number"
            min="1"
            placeholder="Example: 20"
            value={formData.preparationTime}
            onChange={(e) =>
              updateField(
                "preparationTime",
                e.target.value
              )
            }
          />

        </div>

        {/* Quantity */}

        <div className="form-group">

          <label>
            Available Quantity
          </label>

          <input
            type="number"
            min="0"
            placeholder="Example: 25"
            value={formData.quantity}
            disabled={formData.unlimitedQuantity}
            onChange={(e) =>
              updateField(
                "quantity",
                e.target.value
              )
            }
          />

        </div>

      </div>

      <div className="switch-grid">

        <label className="switch-item">

          <input
            type="checkbox"
            checked={formData.unlimitedQuantity}
            onChange={(e) =>
              updateField(
                "unlimitedQuantity",
                e.target.checked
              )
            }
          />

          <span>Unlimited Quantity</span>

        </label>

        <label className="switch-item">

          <input
            type="checkbox"
            checked={formData.isAvailable}
            onChange={(e) =>
              updateField(
                "isAvailable",
                e.target.checked
              )
            }
          />

          <span>Available</span>

        </label>

        <label className="switch-item">

          <input
            type="checkbox"
            checked={formData.availableToday}
            onChange={(e) =>
              updateField(
                "availableToday",
                e.target.checked
              )
            }
          />

          <span>Today's Special</span>

        </label>

        <label className="switch-item">

          <input
            type="checkbox"
            checked={formData.isBestSeller}
            onChange={(e) =>
              updateField(
                "isBestSeller",
                e.target.checked
              )
            }
          />

          <span>Bestseller</span>

        </label>

        <label className="switch-item">

          <input
            type="checkbox"
            checked={formData.isRecommended}
            onChange={(e) =>
              updateField(
                "isRecommended",
                e.target.checked
              )
            }
          />

          <span>Recommended</span>

        </label>

      </div>

    </div>
  );
}

export default AvailabilitySection;